import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { goToPage, setSubscriber, setErrorPage } from '../../WifiManagementBlockSlice';
import { prepareSaleAsync } from '../../WifiManagementBlockAsyncThunk';
import Subscribers from '../../../../Shared/GeneralPages/Subscribers/Subscribers';

const SubscriberPage = (props) => {

    useEffect(() => {

    }, []);

    return (<Subscribers saleType={'internet'} onSelectSubscriber={handleOnSelectSubscriber} selectedSubscriber={props.productSubscriberNo} />);


    function handleOnSelectSubscriber(subscriber) {
        if (subscriber) {
            props.setSubscriber(subscriber);
            if (!subscriber.isJetService) {
                props.setErrorPage('NOT_JET_CUSTOMER_ERROR');
                return;
            }
            if (subscriber.hasDebt || subscriber.hasPaymentMethodIssue) {
                props.setErrorPage('PAYMENT_OR_DEBT_ERROR');
            }
            else {
                props.prepareSaleAsync();
            }
        }
        else {
            props.setErrorPage('NO_SUBSCRIBER_ERROR');
        }
    }

};

const mapStateToProps = (state) => {
    return {
        productSubscriberNo: state.selfcarePage?.selectedSubscriber?.productSubscriberNo
    };
};

const mapDispatchToProps = {
    goToPage,
    setSubscriber,
    setErrorPage,
    prepareSaleAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberPage);
